export default { sha: '5fdcaef13b2bdf2a6b3d301e7ec69b220df44dc7', buildNumber: 'undefined' }
